<template>
  <div class="calculate-profit test" v-loading="loading" style="background: #ffffff; min-height: 100%">
    <el-row type="flex" class="base-info-container">
      <div>
        <gj-image :src="form.imageUrl" :size="80"></gj-image>
      </div>
      <div class="listing--base-content">
        <div class="listing--title">
          <gj-tooltip :text-line="1" :content="form.title ? form.title : '-'">
            {{ form.title }}
          </gj-tooltip>
        </div>
        <el-row style="margin-top: 16px">
          <el-col :span="8">
            <div class="listing--base-info">
              <gj-tooltip :text-line="1" :content="form.productName ? form.productName : '-'">
                <span class="gj-label label-layout" style="font-size: 12px">产品名称 </span
                ><span class="gj-content" style="font-size: 12px">{{
                  form.productName || '-'
                }}</span>
              </gj-tooltip>
            </div>
            <div class="listing--base-info" style="margin-bottom: 0">
              <span class="gj-label label-layout">店铺/站点 </span
              ><span class="gj-content">{{
                (form.marketName || '-') + ':' + (form.countryCode || '-')
              }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="listing--base-info">
              <span class="gj-label label-layout">SKU </span
              ><span class="gj-content">{{ form.sku || '-' }}</span>
            </div>
            <div class="listing--base-info" style="margin-bottom: 0">
              <span class="gj-label label-layout">ASIN </span
              ><span class="gj-content">{{ form.asin || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="listing--base-info">
              <span class="gj-label label-layout">MSKU </span
              ><span class="gj-content">{{ form.msku || '-' }}</span>
            </div>
            <div class="listing--base-info" style="margin-bottom: 0">
              <span class="gj-label label-layout">父ASIN </span
              ><span class="gj-content">{{ form.variationAsin || '-' }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-row>

    <el-row class="result-row" type="flex" justify="space-around" align="middle">
      <el-col :span="3">
        售价
        <span style="padding-left: 12px; font-weight: 600; padding-right: 5px"
          >{{ form.currencySymbol }}{{ form.salePrice }}</span
        >
        <gj-button
          v-if="$permission('listing:adjustSalePrice') || true"
          @click="$changePrice(id)"
          type="text"
          >调价</gj-button
        >
      </el-col>
      <el-col :span="3"
        >毛利润
        <span style="padding-left: 12px; font-weight: 600"
          >{{ form.currencySymbol }}{{ form.profit }}
        </span></el-col
      >
      <el-col :span="3">
        毛利润率<span style="padding-left: 12px; font-weight: 600">{{ form.profitRate }} %</span>
      </el-col>
      <el-col :span="3">
        总成本<span style="padding-left: 12px; font-weight: 600"
          >{{ form.currencySymbol }}{{ form.totalCost.toFixed(PRECISION) }}</span
        >
      </el-col>

      <el-col :span="3"
        >成本利润率 <span style="padding-left: 12px; font-weight: 600">{{ form.costRate }} %</span>
      </el-col>
      <span style="width: 1px; display: inline-block; height: 20px; background: #9cccff"></span>
      <el-col :span="3">
        <span style="padding-right: 12px">可售周转</span> {{ +form.saleableTurnover }}
      </el-col>
      <el-col :span="4">
        <span style="padding-right: 12px"
          >预计售完时间
          <gj-help>
            <div>预计售完日期根据当前可售周转推算而来。</div>
          </gj-help></span
        >
        {{ form.selledDate }}
      </el-col>
    </el-row>
    <!-- :rules="rules" -->
    <el-form
      class="calc-form"
      :model="form"
      ref="form"
      label-position="right"
      label-width="120px"
      :rules="rules"
    >
      <span class="from-title">基本信息</span>
      <el-row>
        <el-col :span="8">
          <el-form-item label="试算类型" prop="resultType">
            <el-radio-group v-model="form.resultType">
              <el-radio v-for="item in resultTypeOptions" :label="item.id" :key="item.id">{{
                item.text
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="'售价'" prop="salePrice" class="has-help">
            <gj-help class="gj-help label-help">
              <div>系统根据毛利润率和下方费用项自动计算出售价</div>
            </gj-help>
            <gj-input
              v-model="form.salePrice"

              style="width:40%"
              :clearable="false"
              @blur="$dataChangeHandel('salePrice')"
              :disabled="form.resultType === 'salePrice'"
            >
              <template slot="append">{{ form.currency }}</template>
            </gj-input>
            <el-checkbox
              @change="$dataChangeHandel('includeTax')"
              v-model="form.includeTax"
              style="margin-left: 13px"
              >含税</el-checkbox
            >
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="毛利润率" prop="profitRate">
            <gj-input
              v-model="form.profitRate"
             style="width:40%"
              :clearable="false"
              @blur="$dataChangeHandel('profitRate')"
              :disabled="form.resultType === 'profitRate'"
            >
              <template slot="append">%</template>
            </gj-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="10">
          <span class="from-title"
            >成本（{{ form.currencySymbol }}{{ form.totalCost.toFixed(PRECISION) }}）</span
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="到库成本" prop="arrivalCost" class="has-help">
            <gj-help class="gj-help label-help">
              <div>默认取成本中心维护的到库成本</div>
            </gj-help>
            <gj-input
              @blur="$dataChangeHandel('arrivalCost')"
              v-model="form.arrivalCost"
              style="width: calc(40% - 30px);"
              :clearable="false"
            >
            </gj-input>
            <gj-select
              v-model="form.inventoryCostSymbol"
              :options="financeCurrencysOption"
              :clearable="false"
              class="no-left-border"
              :width="currencyWidth"
              @change="$dataChangeHandel('arrivalCost')"
            >
            </gj-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="采购成本" prop="purchaseCost" class="has-help">
            <gj-help class="gj-help label-help">
              <div>默认取成本中心维护的采购成本（头程物流成本项）</div>
            </gj-help>
            <gj-input
              @blur="$dataChangeHandel('purchaseCost')"
              v-model="form.purchaseCost"
              style="width: calc(40% - 30px);"
              :clearable="false"
            >
            </gj-input>
            <gj-select
              v-model="form.purchaseCostSymbol"
              :options="financeCurrencysOption"
              :clearable="false"
              class="no-left-border"
              :width="currencyWidth"
              @change="$dataChangeHandel('purchaseCost')"
            >
            </gj-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="space-between">
        <el-col :span="10">
          <span style="padding-right: 10px" class="from-title"
            >平台费（{{ form.currencySymbol }}{{ form.platformCost.toFixed(PRECISION) }}）</span
          >
          <gj-help class="gj-help">
            <div>可选择下方各费用项过去一段时间内的历史数据作为参考值</div>
          </gj-help>
          <el-popover placement="bottom" width="180" trigger="click" v-model="visible">
            <p
              class="reference-value"
              v-for="item in selectValueOption"
              :key="item.id"
              @click="$selectValueChange(item.id)"
            >
              {{ item.text }}
            </p>
            <span style="cursor: pointer" slot="reference"
              ><span style="padding-right: 4px">{{ selectValueMap[form.selectValue] }}</span
              ><i class="el-icon-edit"></i
            ></span>
          </el-popover>
        </el-col>
      </el-row>

      <el-row type="flex">
        <el-col :span="8">
          <el-form-item label="仓储费占比" prop="storageFeeRate" class="has-help">
            <gj-help class="gj-help label-help">
              <div>
                由于仓储费每月15日更新，15日之前暂时无法取到当月的仓储费，因此仓储费占比的参考值可能存在误差，建议您根据实际情况进行调整
              </div>
            </gj-help>
            <gj-input
              @blur="$dataChangeHandel('storageFeeRate')"
              v-model="form.storageFeeRate"
             style="width:40%"
              :clearable="false"
            >
              <template slot="append">%</template>
            </gj-input>
            <span style="margin-left: 10px"
              >{{ form.currencySymbol }}{{ form.storageCost.toFixed(PRECISION) }}</span
            >
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="退款率" prop="refundFeeRate">
            <gj-input
              @blur="$dataChangeHandel('refundFeeRate')"
              v-model="form.refundFeeRate"
             style="width:40%"
              :clearable="false"
            >
              <template slot="append">%</template>
            </gj-input>
            <span style="margin-left: 10px"
              >{{ form.currencySymbol }}{{ form.refundCommission.toFixed(PRECISION) }}</span
            >
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="广告费" prop="adsFeeRate" class="has-help">
            <gj-help class="gj-help label-help">
              <div>可以填写广告花费占比或固定值</div>
            </gj-help>
            <gj-input
              @blur="$dataChangeHandel('adsFeeRate')"
              v-model="form.adsFeeRate"
              style="width: calc(40% - 30px);"
              :clearable="false"
            >
            </gj-input>
            <gj-select
              v-model="form.adType"
              @change="$dataChangeHandel('adsFeeRate')"
              :options="adTypeOption"
              :clearable="false"
              class="no-left-border"
              :width="currencyWidth"
            >
            </gj-select>
            <span style="margin-left: 10px">
              {{ form.currencySymbol }}{{ form.adCost.toFixed(PRECISION) }}</span
            >
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="space-between">
        <el-col :span="8">
          <el-form-item label="渠道佣金比例" prop="channelCommissionRate">
            <gj-input
              @blur="$dataChangeHandel('channelCommissionRate')"
              v-model="form.channelCommissionRate"
             style="width:40%"
              :clearable="false"
            >
              <template slot="append">%</template>
            </gj-input>
            <span style="margin-left: 10px"
              >{{ form.currencySymbol }}{{ form.commission.toFixed(PRECISION) }}</span
            >
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="销售VAT税率" prop="sellVatFee">
            <gj-input
              @blur="$dataChangeHandel('sellVatFee')"
              v-model="form.sellVatFee"
             style="width:40%"
              :disabled="!form.includeTax"
              :clearable="false"
            >
              <template slot="append">%</template>
            </gj-input>
            <span style="margin-left: 10px"
              >{{ form.currencySymbol }}{{ form.VATcommission.toFixed(PRECISION) }}</span
            >
          </el-form-item>
        </el-col>
        <el-col :span="8" style="position: relative;">
          <el-form-item label="配送渠道" prop="fbmCost"  class="height-item">
            <el-radio-group v-model="form.fulfillment" @change="$dataChangeHandel('fulfillment')">
              <el-radio v-for="item in fulfillmentOptions" :label="item.id" :key="item.id">{{
                item.text
              }}</el-radio>
            </el-radio-group>
            <gj-input
              v-show="form.fulfillment === 'FBM'"
              v-model="form.fbmCost"
              style="width:7vw;margin-left: 10px"
              :clearable="false"
              @blur="$dataChangeHandel('fulfillment')"
            >
            </gj-input>
            <gj-select
              v-show="form.fulfillment === 'FBM'"
              v-model="form.fbmCostSymbol"
              @change="$dataChangeHandel('fulfillment')"
              :options="financeCurrencysOption"
              :clearable="false"
              class="no-left-border"
              :width="currencyWidth"
            >
            </gj-select>
            <span style="margin-left: 10px"
              >{{ form.currencySymbol }}{{ form.resultChannelsCommission.toFixed(PRECISION) }}</span
            >
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="space-between">
        <el-col :span="10">
          <span class="from-title"
            >非平台费（{{ form.currencySymbol }}{{ form.othertotalCost.toFixed(PRECISION) }}）</span
          >
        </el-col>
      </el-row>

      <el-row type="flex" justify="space-between">
        <el-col :span="8">
          <el-form-item label="其他费用" prop="otherFee">
            <gj-input
              @blur="$dataChangeHandel('otherFee')"
              v-model="form.otherFee"
              style="width: calc(40% - 30px);"
              :clearable="false"
            >
            </gj-input>
            <gj-select
              v-model="form.otherFeeSymbol"
              :options="adTypeOption"
              :clearable="false"
              :width="currencyWidth"
              class="no-left-border"
              @change="$dataChangeHandel('otherFee')"
            >
            </gj-select>
            <span style="margin-left: 10px"
              >{{ form.currencySymbol }}{{ form.otherFeeValue.toFixed(PRECISION) }}</span
            >
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申报货值" prop="reportValueRate">
            <gj-input
              @blur="$dataChangeHandel('reportValueRate')"
              v-model="form.reportValueRate"
             style="width:40%"
              :clearable="false"
            >
              <template slot="append">%</template>
            </gj-input>
            <span style="color:red;padding-left:5px">*</span> 采购成本
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="关税税率" prop="tariffFeeRate">
            <gj-input
              @blur="$dataChangeHandel('tariffFeeRate')"
              v-model="form.tariffFeeRate"
              :clearable="false"
             style="width:40%"
            >
              <template slot="append">%</template>
            </gj-input>
            <span style="margin-left: 10px"
              >{{ form.currencySymbol }}{{ form.tariff.toFixed(PRECISION) }}</span
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { addDays, format } from 'date-fns';
import changePrice from '../modal/change-price';
import { saveListingCalculateProfitParmas, getListingCalculateProfitParmas } from '@/api/sale';
import {
  getPlatformCost,
  getTotalCost,
  getOthertotalCost,
  geTtariff,
  getOtherCostValue,
  getVATcommission,
  getRefundCommission,
  getAdType,
  getResultChannelsCommission,
  getCommission,
  getStorageCost,
  getSellPrice,
  INITMETHODS,
  handelResult,
  salePriceChange,
  PRECISION,
} from '../helper';
let _that = null;
const financeCurrencysOption = [
  { id: 'USD', text: 'USD' }, // 美国
  { id: 'JPY', text: 'JPY' }, // 日本
  { id: 'CAD', text: 'CAD' }, // 加拿大
  { id: 'GBP', text: 'GBP' }, // 英镑
  { id: 'EUR', text: 'EUR' }, // 欧元
  { id: 'AUD', text: 'AUD' }, // 澳元
  { id: 'BRL', text: 'BRL' }, // 巴西雷亚尔
  { id: 'INR', text: 'INR' }, // 印度
  { id: 'CNY', text: 'CNY' }, // 人名币
  { id: 'MXN', text: 'MXN' }, // 墨西哥
  { id: 'HKD', text: 'HKD' }, // 香港
  { id: 'AED', text: 'AED' }, // 阿联酋
  { id: 'SAR', text: 'SAR' }, //
  { id: 'TRY', text: 'TRY' }, //
];
var validatesellMethods = (rule, value, callback) => {
  if (isNaN(value)) {
    return callback(new Error('请输入数字'));
  } else if (+value < 0) {
    return callback(new Error('请不要输入负数'));
  } else if (String(value).length > 15) {
    return callback(new Error('最多输入十五位字符'));
  } else {
    callback();
  }
};
export default {
  name: 'app-calculate-profit-modal',
  beforeDestroy() {
    saveListingCalculateProfitParmas({ ...this.item, ...this.form });
    window.onbeforeunload = null;
  },
  activated() {
    this.id = this.$route.params.id;
  },
  watch: {
    id: function () {
      this.initData();
    },
  },
  created() {
    _that = this;
    this.id = this.$route.params.id;
    window.onbeforeunload = function (event) {
      saveListingCalculateProfitParmas({ ..._that.item, ..._that.form });
      return null;
    };
    // this.initData();
  },
  data() {
    var validatesalePrice = (rule, value, callback) => {
      if (isNaN(value) && this.form.resultType === 'profitRate') {
        return callback(new Error('请输入数字'));
      } else if (+value < 0 && this.form.resultType === 'profitRate') {
        return callback(new Error('请不要输入负数'));
      } else if (String(value).length > 15) {
        return callback(new Error('最多输入十五位字符'));
      } else {
        callback();
      }
    };
    var validateprofitRate = (rule, value, callback) => {
      if (isNaN(value) && this.form.resultType === 'salePrice') {
        return callback(new Error('请输入数字'));
      } else if (+value < 0 && this.form.resultType === 'salePrice') {
        return callback(new Error('请不要输入负数'));
      } else if (String(value).length > 15) {
        return callback(new Error('最多输入十五位字符'));
      } else {
        callback();
      }
    };
    return {
      currencyWidth: '70px',
      visible: false,
      PRECISION,
      item: {},
      id: '',
      exchangeRateMap: {}, //币种汇率信息-【key -> 币种；value -> 汇率】
      resultTypeOptions: [
        { id: 'profitRate', text: '试算利润' },
        { id: 'salePrice', text: '试算售价' },
      ],
      loading: false,
      form: {
        currency: '', //当前币种
        refundCommission: 0, //退款费
        VATcommission: 0, //销售VAT税费
        sellVatFee: '', //销售VAT税率
        othertotalCost: 0, // 非平台费合计
        tariff: 0, //关税
        otherFeeValue: 0, //其他费用最终值
        tariffFeeRate: '', //关税税率
        reportValueRate: '', //申报货值
        otherFeeSymbol: 'percentage', //其他费用币种
        otherFee: '', //其他费用
        refundFeeRate: '', // 退款率
        adType: 'percentage', //广告费用符号
        adCost: 0, //广告费用
        adsFeeRate: '', //广告费占比
        currencySymbol: '', //币种符号
        fbmCostSymbol: 'USD', //FBM币种
        resultChannelsCommission: 0, // 目标渠道配送费
        fbmCost: 0, //FBM配送费
        trialWarehouseFee: 0, //FBA配送费
        fulfillment: 'FBA', //配送渠道：
        commission: 0, //渠道佣金
        channelCommissionRate: '', //渠道佣金比例
        storageCost: 0, // 仓储费
        storageFeeRate: '', //仓储费占比
        platformCost: 0, //平台总费用
        selectValue: 'lastThreeMonth', //参考时间
        inventoryCostSymbol: 'USD', //到库币种
        arrivalCost: 0, //到库成本
        purchaseCostSymbol: 'USD', //采购币种
        purchaseCost: 0, //采购成本
        includeTax: false, //是否含税
        ccc: false,
        salePrice: 0, //售价
        profit: 0, //毛利润
        profitRate: 0, //毛利润率
        totalCost: 0, //总成本
        costRate: 0, //成本利润率
        revolveCanSell: '_', //可售周转
        selledDate: '_', //预计售完日期
        resultType: 'profitRate', // 试算类型
      },
      adTypeOption: [{ id: 'percentage', text: '%' }, ...financeCurrencysOption],
      fulfillmentOptions: [
        { id: 'FBA', text: 'FBA' },
        { id: 'FBM', text: 'FBM' },
      ],
      selectValueMap: {
        empty: '不参考历史数据',
        lastOneMonth: '取近一个月的历史数据为参考',
        lastThreeMonth: '取近三个月的历史数据为参考',
        lastSixMonth: '取近半年的历史数据为参考',
        lastOneYear: '取近一年的历史数据为参考',
      },
      selectValueOption: [
        { id: 'empty', text: '不参考历史数据' },
        { id: 'lastOneMonth', text: '取近一个月的历史数据为参考' },
        { id: 'lastThreeMonth', text: '取近三个月的历史数据为参考' },
        { id: 'lastSixMonth', text: '取近半年的历史数据为参考' },
        { id: 'lastOneYear', text: '取近一年的历史数据为参考' },
      ],
      financeCurrencysOption,
      rules: {
        salePrice: [{ validator: validatesalePrice }],
        profitRate: [{ validator: validateprofitRate }],
        purchaseCost: [{ validator: validatesellMethods }],
        arrivalCost: [{ validator: validatesellMethods }],
        storageFeeRate: [{ validator: validatesellMethods }],
        channelCommissionRate: [{ validator: validatesellMethods }],
        fbmCost: [{ validator: validatesellMethods }],
        adsFeeRate: [{ validator: validatesellMethods }],
        refundFeeRate: [{ validator: validatesellMethods }],
        sellVatFee: [{ validator: validatesellMethods }],
        otherFee: [{ validator: validatesellMethods }],
        reportValueRate: [{ validator: validatesellMethods }],
        tariffFeeRate: [{ validator: validatesellMethods }],
      },
    };
  },
  methods: {
    initData() {
      this.loading = false;
      getListingCalculateProfitParmas({ id: this.id, flag: true })
        .then((res) => {
          // 非平台相关
          this.exchangeRateMap = res.exchangeRateMap;
          this.form = { ...this.form, ...res, ...res.noPlatformVO, ...res.platformVO };
          this.form.ownSalePrice = res.salePrice;
          this.form.salePrice = res.salePrice || res.yourPrice;
          const defaultIncludeTax = ['UK', 'DE', 'FR', 'IT', 'ES', 'JP', 'IN', 'NL', 'SE', 'PL'];
          this.form.includeTax = defaultIncludeTax.includes(this.form.countryCode);
          const timeNum = Math.floor(this.form.saleableTurnover);
          this.form.selledDate = format(addDays(new Date(), +timeNum), 'yyyy-MM-dd');
          for (let method of INITMETHODS) {
            method(this);
          }
          if (!this.form.selectValue) {
            this.form.selectValue = 'lastThreeMonth';
          }
          for (let key in this.form) {
            this.handeData(key);
          }
        })
        .complete(() => (this.loading = false));
    },
    $changePrice(id) {
      const vm = this;
      const modal = this.$gjCreate(changePrice, {
        props: {
          id,
          item: {
            ...this.form,
            salePrice: this.form.ownSalePrice,
            saleStartDate: '',
            saleEndDate: '',
          },
        },
        on: {
          after() {
            modal.$gjDestroy();
          },
        },
      });
    },
    handeData(type) {
      if (!isNaN(this.form[type]) && typeof this.form[type] !== 'boolean') {
        this.form[type] = +this.form[type];
        if (this.form[type] != 0) {
          this.form[type] = +this.form[type].toFixed(4);
        }
      }
    },
    $dataChangeHandel(type) {
      this.handeData(type);
      const that = _that;
      that.$refs.form.validate((valid) => {
        if (valid) {
          if (that.form.resultType !== 'profitRate') {
            getTotalCost(that);
            getSellPrice(that);
            salePriceChange(that);
          }
          switch (type) {
            case 'arrivalCost':
              getTotalCost(that);
              break;
            case 'purchaseCost':
              getTotalCost(that);
              geTtariff(that);
              break;
            case 'includeTax':
              if (that.form.resultType === 'profitRate') {
                getVATcommission(that);
                getPlatformCost(that);
              }
              break;
            case 'profitRate':
              break;
            case 'storageFeeRate':
              getStorageCost(that);
              getPlatformCost(that);
              break;
            case 'channelCommissionRate':
              getCommission(that);
              getPlatformCost(that);
              break;
            case 'fulfillment':
              getResultChannelsCommission(that);
              getPlatformCost(that);
              break;
            case 'adsFeeRate':
              getAdType(that);
              getPlatformCost(that);
              break;
            case 'refundFeeRate':
              getRefundCommission(that);
              getPlatformCost(that);
              break;
            case 'sellVatFee':
              getVATcommission(that);
              getPlatformCost(that);
              break;
            case 'otherFee':
              getOtherCostValue(that);
              getOthertotalCost(that);
              break;
            case 'tariffFeeRate':
              geTtariff(that);
              getOthertotalCost(that);
              break;
            case 'salePrice':
              salePriceChange(that);
              break;
            default:
              break;
          }
          handelResult(that);
        } else {
          return false;
        }
      });
    },
    $selectValueChange(val) {
      this.visible = false;
      this.form.selectValue = val;
      getListingCalculateProfitParmas({ id: this.id, recentDate: val, flag: false }).then((res) => {
        // 平台相关
        this.form = { ...this.form, ...res.platformVO };
        for (let key in this.form) {
          this.handeData(key);
        }
        if (this.form.resultType === 'profitRate') {
          getCommission(this);
          getStorageCost(this);
          getAdType(this);
          getRefundCommission(this);
          getPlatformCost(this);
        } else {
          getSellPrice(this);
          salePriceChange(this);
        }
        handelResult(this);
      });
    },
  },
};
</script>

<style scoped lang='scss'>



.calculate-profit {
  /deep/ .el-radio__label{
    color: #333333 !important;
  }
  .height-item{
    /deep/.el-form-item__content{
      display: flex;
    flex-direction: row;
    align-items: center;
    }
  }
  height: 100%;
    overflow: overlay;
  /deep/ .form-item__content {
    position: relative;
  }
  /deep/ .el-form-item {
    margin-bottom: 25px;
  }
  /deep/.has-help .el-form-item__label {
    padding-right: 30px;
  }
}

.result-row {
  width: 90%;
  margin-left: 20px;
  font-size: 12px;
  background: #edf7ff;
  height: 50px;
  border: 1px solid #73b2ff;
  box-sizing: border-box;
  border-radius: 2px;
}
.calc-form {
  margin: 20px 0;
  margin-left: 20px;
  width: 90%;
  font-size: 12px;
}
.base-info-container {
  margin-left: 20px;
  width: 1300px;
  padding: 16px 0;
}

.from-title {
  margin-bottom: 18px;
  display: inline-block;
  font-weight: bold;
  font-size: 12px;
  font-size: 12px;
  line-height: 12px;
  padding-left: 6px;
  border-left: 4px solid #1f6eef;
}
.no-left-border {
  /deep/ .el-input__inner {
    border-left-color: transparent;
    &:hover,
    &:focus {
      border-left-color: #1f6eef;
    }
  }
}
.listing--base-content {
  margin: 0 20px 0 0;
  padding-left: 20px;
  flex: 1;
}

.listing--title {
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
}

.listing--base-info {
  margin-bottom: 12px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}

/deep/ .gj-modal--custom .el-dialog {
  height: 610px !important;
  width: 1200px !important;
}

@media (max-height: 768px) {
  /deep/ .gj-modal--custom .el-dialog {
    height: 578px !important;
  }
}

.left-container,
.right-container {
  border: 1px solid #d9d9d9;
  font-size: 12px;
}

.op-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.op-button-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.calc-title {
  padding: 8px 10px;
  border-bottom: 1px solid #d9d9d9;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
}

.form-item--text {
  margin: 0;
}

.reference-value {
  cursor: pointer;
  margin: 0;
  padding: 10px;
  border-radius: 5px;
}
.reference-value:hover {
  background-color: #f5f7fa;
}
.calc-total-result {
  border-bottom: 1px solid #d9d9d9;
  padding: 20px 40px;
}

.result-number {
  line-height: 30px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
}

.calc-detail-result {
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
  font-variant: tabular-nums;
  padding: 20px 20px 0;
}

.calc-detail-result .title {
  font-weight: bold;
}
.calc-detail-result .title,
.calc-detail-result .detail {
  margin-bottom: 10px;
}

.listing--base-info > span {
  font-size: 12px !important;
}

.label-layout {
  display: inline-block;
  width: 60px;
  text-align: right;
  margin-right: 10px;
}
.gj-label {
  color: #666;
}
.gj-help {
  transform: translateX(-10px);
}
.label-help {
  position: absolute;
  left: -15px;
  top: 8px;
}
</style>
